import { ref, watch, computed } from '@vue/composition-api';
import store from '@/store';
import { useToast } from 'vue-toastification/composition';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
import { useUtils as useI18nUtils } from '@core/libs/i18n'

export default function useCategoryList() {
    const tableColumns = [
        { key: 'icon', label: 'Icon', sortable: false },
        { key: 'title', label: 'Title', sortable: false },
        { key: 'slug', label: 'Slug', sortable: false },
        { key: 'is_active', label: 'Status', sortable: false },
        { key: 'action', label: '#', sortable: false }
    ];
    const toast = useToast()
    const allergyData = ref(null)
    const isAllergyFormSidebarActive = ref(false)
    const searchQuery = ref('')
    const refAllergyListTable = ref(null)
    const foodAllergies = ref([])
    const allergies = ref([])
    const sortBy = ref('id')
    const isSortDirDesc = ref(true)
    const perPage = ref(10)
    const currentPage = ref(1)
    const totalFoodAllergies = ref(0)
    const getLocalSite = JSON.parse(localStorage.getItem('site'));
    const statusFilter = ref(null)
    const dataMeta = computed(() => {
        const localItemsCount = refAllergyListTable.value ? refAllergyListTable.value.localItems.length : 0
        return {
            from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
            to: perPage.value * (currentPage.value - 1) + localItemsCount,
            of: totalFoodAllergies.value,
        }
    })

    const refetchAllergyData = () => {
        refAllergyListTable.value.refresh()
        fetchAllergyData();
    }

    watch([currentPage, perPage, searchQuery, statusFilter], () => {
        refetchAllergyData()
    })

    const fetchAllergyData = (ctx, callback) => {
        const offset = perPage.value*(currentPage.value-1);

        store
            .dispatch('app-food/getFoodAllergies', {
                limit: perPage.value,
                offset:offset,
                keywords: searchQuery.value,
                sites_id: getLocalSite.id
            })
            .then(response => {
                foodAllergies.value = response.data.data
                totalFoodAllergies.value = response.data.total
            })
            .catch(() => {
                toast({
                    component: ToastificationContent,
                    props: {
                        title: "Error fetching Allergy' list",
                        icon: 'AlertTriangleIcon',
                        variant: 'danger',
                    },
                })
            })
    }

    const updateAllergy = (data) => {
        allergyData.value = data
        isAllergyFormSidebarActive.value = true
    }

    const resolveAllergyStatusVariant = status => {
        if (status ) return 'success'
        if (!status ) return 'secondary'
        return 'primary'
    }

    const resolveAllergyStatusnameVariant = status => {
        if (status) return 'Active'
        if (!status) return 'Inactive'
        return 'primary'
    }

    const deleteData = (id) => {
        store.dispatch('app-food/deleteFoodAllergy', id).then(response => {
          toast({
            component: ToastificationContent,
            props: {
              title: "Delete Success",
              icon: 'AlertTriangleIcon',
              variant: 'success',
            },
          })
          refetchAllergyData();
        }).catch(()=>{
          toast({
            component: ToastificationContent,
            props: {
              title: "Error Delete User",
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
    }

    return {
        tableColumns,
        allergyData,
        isAllergyFormSidebarActive,
        searchQuery,
        refAllergyListTable,
        foodAllergies,
        sortBy,
        isSortDirDesc,
        dataMeta,
        perPage,
        currentPage,
        totalFoodAllergies,
        allergies,
        fetchAllergyData,
        refetchAllergyData,
        statusFilter,
        resolveAllergyStatusVariant,
        resolveAllergyStatusnameVariant,
        updateAllergy,
        deleteData,
    }
}